import { type SocialIcon } from "@client/types/Fields";
import React from "react";
import "./style.less";

export interface SocialProps {
  items: SocialIcon[];
  className: string;
  isVisible: boolean;
}

export default (props: SocialProps) =>
  props.isVisible ? (
    <div className={`social-icons ${props.className}`}>
      <ul>
        {props.items.map((item) => (
          <li key={item.icon} className={`social-${item.icon}`}>
            <a href={item.link}>
              <i className={`fab fa-${item.icon}`}></i>
            </a>
          </li>
        ))}
      </ul>
    </div>
  ) : null;
